import React, { useEffect, useState } from "react";
import { getNews } from '../Service/Api';  
import LazyLoad from 'react-lazyload';  
import { Link } from "react-router-dom";
const Activities = () => {
    const [data, setData] = useState([]); // State for gallery data
    const [loading, setLoading] = useState(true); // State for loading indicator 
  
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    useEffect(() => {
      const fetchData = async () => {
        try {
          const newsData1 = await getNews(); 
          
          const sortedData = newsData1.sort((a,b) => {
                const dataA = new Date(a.fromDate);
                const dataB = new Date(b.fromDate);
                return  dataB - dataA;
          })
          console.log(sortedData)
          setData(sortedData);
        } catch (error) {
          console.error("Error fetching gallery data:", error);
          // Handle error (e.g., show error message)
        } finally {
          setLoading(false); // Set loading to false after data fetching is complete
        }
      };
      fetchData();
    }, []);
   
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
  };  
  return (
    <>
        <div className="recentactivites recentactivitesnew">
            <marquee onMouseOver={(event) => event.currentTarget.stop()} direction="up" onMouseOut={(event) => event.currentTarget.start()}>
                 {data.length > 0 ? (data.map((item, index) => (  
                <div class="recentactivitesbox" key={index}>
                <div class="recentactivitesimg">
                <LazyLoad>
                {item?.image.length > 0 ? (
                    <img src={`https://webapi.entab.info/api/image/${item?.image[0]}`} alt="Gallery" className="img-fluid"/>
                ) : (
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/news.jpg" alt="Gallery Placeholder" className="img-fluid" />
                )}
            </LazyLoad> 
                </div>
                  <div class="recentactivitedesc">
                      <h6><span>{item.title}</span></h6>
                      <p>{item.description}</p>
                      <p><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/cal.png" className="img-fluid"/> {formatDate(item.fromDate)} </p> 
                  </div>
                  {item.attachments && item.attachments.length > 0 && ( 
                    <Link to={`https://webapi.entab.info/api/image/${item?.attachments[0]}`} target="_blank">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/arrow.gif" className="img-fluid"/>
                    </Link> 
                )} 
              </div> 
              ))
              ) : (
                   <>
                      
                      
                   </>
              )}  
              </marquee>
        </div>
    </>
  )
}

export default Activities
